import {
  borderRadius,
  KestrixButton,
  shadows,
  transitions,
  typography
} from '@shared'

export const LoginButton = ({ isSubmitting }: { isSubmitting: boolean }) => {
  return (
    <KestrixButton
      type="submit"
      variant="primary"
      size="large"
      fullWidth
      disabled={isSubmitting}
      loading={isSubmitting}
      sx={{
        borderRadius: borderRadius.md,
        fontSize: typography.fontSize.base,
        fontWeight: typography.fontWeight.semibold,
        textTransform: 'none',
        transition: transitions.base,
        '&:hover': {
          boxShadow: shadows.base,
          transform: 'translateY(-1px)'
        },
        '&:active': {
          transform: 'translateY(0)'
        }
      }}
      data-testid="login-button"
    >
      {isSubmitting ? 'Logging in...' : 'Log in'}
    </KestrixButton>
  )
}
